/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, Input } from '@angular/core';
import { DashboardAverageItem } from '@gh/builder-shared-data';
import { isNil } from 'lodash';

@Component({
  selector: 'gh-builder-average-widget',
  template: require('./average-widget.component.html'),
  styles: [require('./average-widget.component.scss')],
})
export class AverageWidgetComponent {
  @Input() items: DashboardAverageItem[];

  isValueExists(value: any): boolean {
    return !isNil(value);
  }
}
